import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Shield } from 'lucide-react';
import { COMPANY } from '../../config/company';

const InsuranceInfoSection = ({
  language,
  lead,
  handleInputChange
}) => {
  return (
    <Card className="border-blue-200">
      <CardHeader 
        className="cursor-pointer hover:bg-blue-50 transition-colors rounded-t-lg"
        style={{ backgroundColor: lead.show_insurance_in_proposal ? COMPANY.primaryColor : '#f0f9ff' }}
        onClick={() => handleInputChange('show_insurance_in_proposal', !lead.show_insurance_in_proposal)}
      >
        <CardTitle className={`flex items-center justify-between ${lead.show_insurance_in_proposal ? 'text-white' : 'text-blue-800'}`}>
          <span className="flex items-center">
            <Shield className="mr-2 h-5 w-5" />
            {language === 'es' ? 'Información del Seguro' : 'Insurance Information'}
            {(lead.insurance_claim_number || lead.insurance_policy_number) && (
              <Badge className="ml-2 bg-green-500 text-white text-xs">
                {language === 'es' ? 'Con datos' : 'Has data'}
              </Badge>
            )}
          </span>
          <label className="flex items-center text-sm font-normal" onClick={(e) => e.stopPropagation()}>
            <input 
              type="checkbox" 
              checked={lead.show_insurance_in_proposal || false}
              onChange={(e) => handleInputChange('show_insurance_in_proposal', e.target.checked)}
              className="mr-2 h-4 w-4"
            />
            {language === 'es' ? 'Incluir en Propuesta' : 'Include in Proposal'}
          </label>
        </CardTitle>
      </CardHeader>
      {lead.show_insurance_in_proposal && (
        <CardContent className="pt-4 space-y-4 bg-blue-50/30">
          {/* Claim & Policy Info */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-sm">
                {language === 'es' ? 'Número de Reclamo' : 'Claim Number'}
              </Label>
              <Input 
                value={lead.insurance_claim_number || ''} 
                onChange={(e) => handleInputChange('insurance_claim_number', e.target.value)} 
                className="bg-white" 
              />
            </div>
            <div>
              <Label className="text-sm">
                {language === 'es' ? 'Número de Póliza' : 'Policy Number'}
              </Label>
              <Input 
                value={lead.insurance_policy_number || ''} 
                onChange={(e) => handleInputChange('insurance_policy_number', e.target.value)} 
                className="bg-white" 
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-sm">
                {language === 'es' ? 'Fecha de Pérdida' : 'Date of Loss'}
              </Label>
              <Input 
                type="date" 
                value={lead.insurance_date_of_loss || ''} 
                onChange={(e) => handleInputChange('insurance_date_of_loss', e.target.value)} 
                className="bg-white" 
              />
            </div>
            <div>
              <Label className="text-sm">
                {language === 'es' ? 'Causa de Pérdida' : 'Cause of Loss'}
              </Label>
              <Input 
                value={lead.insurance_cause_of_loss || ''} 
                onChange={(e) => handleInputChange('insurance_cause_of_loss', e.target.value)} 
                className="bg-white" 
              />
            </div>
          </div>
          <p className="text-xs text-blue-600 italic">
            {language === 'es' 
              ? '* Esta información aparecerá en el PDF de la propuesta cuando esté habilitado' 
              : '* This information will appear in the proposal PDF when enabled'}
          </p>
        </CardContent>
      )}
    </Card>
  );
};

export default InsuranceInfoSection;
